import { render } from "./performanceStatistics.vue?vue&type=template&id=6a5d3250&scoped=true"
import script from "./performanceStatistics.vue?vue&type=script&lang=js"
export * from "./performanceStatistics.vue?vue&type=script&lang=js"

import "./performanceStatistics.vue?vue&type=style&index=0&id=6a5d3250&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a5d3250"

export default script